<template>
  <span>{{ decoratedAmount }}</span>
</template>

<script>

export default {
  name: 'MpnLabelNumber',
  props: {
    amount: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    decoratedAmount() {
      if (typeof this.amount === 'string') {
        return this.amount;
      }

      const price = Math.floor(this.amount).toLocaleString();
      return price;
    },

  },
  methods: {

  },

};
</script>
